var map = {
	"./baitiao.png": 427,
	"./close.png": 183,
	"./cxm-download/1.png": 216,
	"./cxm-download/10.png": 217,
	"./cxm-download/11.png": 218,
	"./cxm-download/12.png": 219,
	"./cxm-download/2.png": 220,
	"./cxm-download/3.png": 221,
	"./cxm-download/4.png": 222,
	"./cxm-download/5.png": 223,
	"./cxm-download/6.png": 224,
	"./cxm-download/7.png": 225,
	"./cxm-download/8.png": 226,
	"./cxm-download/9.png": 227,
	"./cxm-download/bg.png": 228,
	"./cxm-download/btn.png": 126,
	"./cxm-share/arrow.png": 127,
	"./cxm-share/download.png": 128,
	"./cxm-share/header-small.png": 229,
	"./cxm-share/header.png": 230,
	"./cxm-share/headpic.png": 129,
	"./cxm-share/say.png": 231,
	"./download-cxm-app.png": 428,
	"./download-cxm-app1.png": 429,
	"./download-cxm-app2.png": 430,
	"./icon-down.png": 232,
	"./icon-up.png": 233,
	"./icon_left.png": 34,
	"./jieqing.png": 431,
	"./mask1.png": 106,
	"./order-header-bg.png": 432,
	"./order-header-bg2.png": 433,
	"./sheqian.png": 434,
	"./store/1.png": 234,
	"./store/2.png": 235,
	"./store/download.png": 236,
	"./store/friend.png": 155,
	"./store/friend2.png": 156,
	"./store/home-header-bg.png": 237,
	"./store/inventory-header.png": 238,
	"./store/inventory-title.png": 239,
	"./store/phone.png": 157,
	"./store/phone2.png": 240,
	"./store/pic.png": 241,
	"./store/shadow.png": 242,
	"./store/stall-address.png": 158,
	"./store/statistics1.png": 159,
	"./store/statistics2.png": 160,
	"./store/store.png": 161,
	"./tuikuan.png": 435,
	"./zuofei.png": 436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;